import type {Privilege} from 'src/action-creators/roles';

import {useSelector} from 'react-redux';

import {hasPrivilege} from 'src/utils/accounts';


export default function usePrivilege(privilege: Privilege): boolean {
  // @ts-expect-error - TS2345 - Argument of type 'DefaultRootState' is not assignable to parameter of type '{ accounts: State; }'.
  return useSelector((state) => hasPrivilege(state, privilege));
}
